export const TABLET = 1024;
export const DESKTOP = 1280;
export const ERROR = 1;